import React from 'react';
import './PageToolbar.css';

export function PageToolbar({ left, right }) {
  return (
    <div className="device-toolbar">
      <div className="device-toolbar-left">{left}</div>
      <div className="device-toolbar-right">{right}</div>
    </div>
  );
}
